import { AppStoreState } from '../../appStore';

export const userNameSelector = (state: AppStoreState) => state.user.name;

export const logOutSelector = (state: AppStoreState) => state.user.logOut;
